export default __webpack_public_path__ + "static/media/books2-afterA.1e25a53d.jpg";